"use client";

// TEMPORARY dev-only cosmetic masking for screen recordings: every rendered
// text node containing a *.tess-dev.de dev host is rewritten to "test.de".
// Applies to ALL text nodes including contenteditable (Tiptap/ProseMirror
// email editors) — NOTE: ProseMirror syncs DOM mutations back into its
// model, so text typed/rendered in an editor is REALLY replaced there and a
// sent mail will contain the masked link. Fine for training-sandbox mails,
// but that's why this must be REMOVED when the recordings are done.

import { useEffect } from "react";

const FROM = /[a-z0-9][a-z0-9.-]*\.tess-dev\.de/gi;
const TO = "test.de";

function maskTextNodes(root: Node) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode: (node) => {
      FROM.lastIndex = 0;
      return node.nodeValue && FROM.test(node.nodeValue)
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT;
    },
  });
  const hits: Text[] = [];
  for (let n = walker.nextNode(); n; n = walker.nextNode()) hits.push(n as Text);
  for (const text of hits) {
    FROM.lastIndex = 0;
    text.nodeValue = text.nodeValue!.replace(FROM, TO);
  }
}

export function DevDomainMasker() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;
    maskTextNodes(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === "characterData" && m.target.nodeValue) {
          FROM.lastIndex = 0;
          if (FROM.test(m.target.nodeValue)) maskTextNodes(m.target.parentNode ?? m.target);
        }
        for (const added of m.addedNodes) maskTextNodes(added);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, []);
  return null;
}
